import React, { useContext } from "react";
import "./LoginMobileNumber.css";
import InputText from "../../../../../components/TextComponent/textInput";
import Button from "../../../../../components/ButtonComponent/Button";
import { LoginMobileNumberContext } from "../LoginMobileNumberview";
import AlertBox from "../../../../../components/alertComponent/AlertBox";
import Spinner from "../../../../../components/spinner/Spinner";

const LoginMobileNumber = ({ textContents }) => {
  const {
    setRegMobileNumber,
    onSubmitClik,
    regMobileNumber,
    showAlert,
    setShowAlert,
    alertMessage,
    apiStatus
  } = useContext(LoginMobileNumberContext);

  return (
    <div>
      <div className="loginContainer">
        <div className="col-xl-4 col-lg-5 col-md-5 col-sm-6 col-10 mainBoxEnterOtp">
          { apiStatus === 'fetching'  ? <Spinner /> : null}
          <div className="registerPhnoText">
            <label>{textContents.yourRegisteredMobileNo}</label>
            <h6>{textContents.digit}</h6>
          </div>
          <div className="mobileNumberInput">
            <InputText
              maxLength={10}
              type="number"
              value={regMobileNumber}
              onKeyDown={(e) =>
                ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
              }
              onChange={(e) => {
                setRegMobileNumber(e.target.value);
              }}
              onInput={(e) => (e.target.value = e.target.value.slice(0, 10))}
            />
          </div>
          <div className="credentialSubmit">
            <Button
              onClick={() => {
                onSubmitClik();
              }}
              text={textContents.submit}
            />
          </div>
        </div>
      </div>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        title={textContents.alert}
        alertMessage={alertMessage}
      />
    </div>
  );
};

export default LoginMobileNumber;
